module.exports = __webpack_public_path__ + "img/1_010.948bbfc7.jpg";